import { Link } from "react-router-dom";
import "./Sidebar.scss";

function Sidebar(props) {
  return (
    <section className="video">
      <div className="video__wrapper">
        <h3 className="video__heading">Next Videos</h3>
        <ul className="video__card-list">
          {props.videos
            .filter((video) => video.id !== props.video.id)
            .map((video) => (
              <Link
                to={`/videos/${video.id}`}
                className="video__card"
                key={video.id}
              >
                <img
                  className="video__still"
                  src={video.image}
                  alt={video.title}
                ></img>
                <div className="video__card--right">
                  <h3 className="video__title">{video.title}</h3>
                  <p className="video__creator">{video.channel}</p>
                </div>
              </Link>
            ))}
        </ul>
      </div>
    </section>
  );
}

export default Sidebar;
